<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Log Detail</strong>
            <span class="float-right">Date : {{model.created_at | datetime}}</span>
          </div>
          <!-- <pre>{{model}}</pre> -->
          <b-row>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_sent_at" v-b-tooltip.hover>sent_at</label><br></b>
                <label for="ph_sent_at" v-b-tooltip.hover>{{model.sent_at | datetime}}</label>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <b><label for="ph_result" v-b-tooltip.hover>Result</label><br></b>
                <b-badge  :variant="model.is_success ? 'success' : 'danger'"> {{model.is_success ? 'success' : 'failed'}} </b-badge>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <b-form-group>
                <b><label for="ph_email_to" v-b-tooltip.hover>To</label><br></b>
                <label for="ph_email_to" v-b-tooltip.hover>
                  <pre for="ph_email_to" v-b-tooltip.hover>{{model.email_to || "-"}}</pre>
                </label>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>CC</label><br></b>
                <pre for="ph_username" v-b-tooltip.hover>{{model.email_cc || "-"}}</pre>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b><label for="ph_username" v-b-tooltip.hover>BCC</label><br></b>
                <pre for="ph_username" v-b-tooltip.hover>{{model.email_bcc || "-"}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_type" v-b-tooltip.hover>Type(template)</label><br></b>
                <label for="ph_type" v-b-tooltip.hover>{{model.type}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_title" v-b-tooltip.hover>Title</label><br></b>
                <label for="ph_title" v-b-tooltip.hover>{{model.title}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="model.preview">
            <b-col>
              <label for="ph_contents" v-b-tooltip.hover>Preview</label><br>
              <samp v-html="model.preview" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px; min-height: 1000px;" class="w-100 d-inline-block">
              </samp>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col md="12">
              <b-form-group>
                <b><label for="ph_contents" v-b-tooltip.hover>Content Data</label><br></b>
                <pre for="ph_contents" v-b-tooltip.hover>{{model.content}}</pre>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-button size="sm" class="float-right" variant="primary" @click="list">List</b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Api } from '@/service';

export default {
  data : () => {
    return {
      model : {},
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_mail'}); },
    async get( id = this.$route.params) {
      console.log('log.mail.detail.vue', 'load item', id);
      try {
        let rs = await Api.Manager_Call('log.mail', 'detail', { id : Number(id.id) })
        this.model = rs.body;


        let content = [];
        let json_content = JSON.parse(this.model.contents)
        let k_c = Object.keys(json_content);
        for (let i = 0; i < k_c.length; i++) {
          if(k_c[i] == 'id') { continue; }
          content.push(`${k_c[i]} : ${json_content[k_c[i]]}`);
        }
        this.model.content = content.join("\n")
        this.model.email_cc = this.model.email_cc && this.model.email_cc.indexOf(",") > -1 ?  this.model.email_cc.split(",").join("\n") : this.model.email_cc
        this.model.email_to = this.model.email_to && this.model.email_to.indexOf(",") > -1 ?  this.model.email_to.split(",").join("\n") : this.model.email_to
        this.model.email_bcc = this.model.email_bcc && this.model.email_bcc.indexOf(",") > -1 ?  this.model.email_bcc.split(",").join("\n") : this.model.email_to

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('log.mail.detail.vue', 'created'); },
  destroyed() { console.log('log.mail.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.mail.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
